package learning.components


import antd.alert.alert
import antd.avatar.avatar
import antd.button.button
import antd.card.card
import antd.comment.comment
import antd.icon.messageOutlined
import antd.layout.content
import antd.layout.space
import antd.list.ListComponent
import antd.list.list
import antd.list.listItem
import antd.list.listItemMeta
import antd.message.message
import antd.pageheader.pageHeader
import com.jingfangpai.common.orm.mapping.Comment
import com.jingfangpai.common.orm.mapping.MedicalRecord
import com.jingfangpai.common.orm.mapping.enums.ContentType
import com.jingfangpai.common.orm.mapping.enums.UserPermissionCommunity
import com.jingfangpai.common.orm.mapping.enums.UserPermissionMedicalRecord
import com.jingfangpai.content.model.ContentVo
import react.*
import community.containers.TopicViewPageContext
import external.toJsObject
import kotlinext.js.js
import kotlinx.html.js.onClickFunction
import kotlinx.html.unsafe
import learning.containers.TcmFaqViewPageContext
import react.dom.*
import react.router.dom.useHistory
import setTitle
import user.service.CurrentUserPermission

external interface TcmFaqViewProps : RProps {
    var id:String
}

data class TcmFaqViewContextData(var placeHolderFunction: (param: String) -> Unit)

val TcmFaqView = functionalComponent<TcmFaqViewProps> { props ->

    val ctx = useContext(TcmFaqViewPageContext)
    val (topic,setTopic) = useState(ContentVo().apply{
        comments = setOf()
    })
    val history = useHistory()

    useEffectOnce {
        ctx.getContent(ContentType.TcmFaq,props.id,{ resp ->
            if(resp.ok() && resp.data != null){
                setTopic(resp.data!!)
                setTitle(resp.data?.title)
            }else{
                message.error("获取问题出错：${resp.message}")
            }
        },{
            message.error("获取问题出错：${it.message}")
        })
    }

    div("TcmFaqView") {
        attrs {
            jsStyle = kotlinext.js.js {
                padding = "40px"
            }
        }

        pageHeader {
            attrs{
                style = js{
                    background="#f9f9f9";
                    marginBottom= "30px";
                    border= "1px solid #f0f0f0";
                }
                title = "${topic.title?:""}"
                subTitle = ""
                avatar = "https://gw.alipayobjects.com/zos/rmsportal/mqaQswcyDLcXyDKnZfES.png"
                tags = "开放讨论中"
                //extra = buildElement {  }
            }
            div{
                div{
                    alert {
                        attrs{
                            style = kotlinext.js.js {
                                margin = "16px 0"
                            }
                            message = buildElement {
                                div{
                                    attrs.unsafe {
                                        +"${topic.content?:""}"
                                    }
                                }
                            }
                        }
                    }
                }
                div{
                    a("action-link"){
                        attrs{
                            onClickFunction = {
                                    if (CurrentUserPermission.hasPerm(UserPermissionCommunity.评论话题)){
                                        history.push(CommunityRoute.TopicCommentEdit.link.url.replace(":topicId",topic.id?:"").replace(":commentId","new"))
                                    }else{
                                        message.error("对不起，您暂不能回复问题")
                                    }

                            }
                        }
                        img("","https://gw.alipayobjects.com/zos/rmsportal/MjEImQtenlyueSmVEfUD.svg"){

                        }
                        +"我有话说"

                    }
                }
            }
        }


        card {
            attrs{
                title = "讨论"
                /*extra = buildElement {

                }*/
            }
            list<Comment, ListComponent<Comment>> {
                attrs{
                    className = "comment-list"
                    header = if(topic.comments.isNotEmpty()) "${topic.comments.size}条讨论" else "暂无讨论"
                    itemLayout = "horizontal"
                    dataSource = topic.comments.toTypedArray()
                    renderItem = {commentItem,index ->
                        buildElement {
                            li {
                                comment {
                                    attrs{
                                        //actions = arrayOf()
                                        author = commentItem.createdBy
                                        avatar = "https://joeschmoe.io/api/v1/random"
                                        content = buildElement {
                                            div{
                                                div{
                                                    attrs.unsafe {
                                                        +(commentItem.comment?:"")
                                                    }
                                                }
                                                div{
                                                    button{
                                                        attrs{
                                                            type = "link"
                                                            onClick = {
                                                                history.push(CommunityRoute.TopicCommentEdit.link.url.replace(":topicId",topic.id?:"").replace(":commentId",commentItem.id?:""))
                                                            }
                                                        }
                                                        +"修改回复"
                                                    }
                                                }
                                            }
                                        }
                                        datetime = commentItem.timestamp
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
